// extracted by mini-css-extract-plugin
export default {"smallWidth":"DailyPointReport_smallWidth__Ze8Wz","mediumWidth":"DailyPointReport_mediumWidth__gBYYz","largeWidth":"DailyPointReport_largeWidth__8+-hO"};